import { useState } from "react";
import emailjs from "emailjs-com";
import "./ContactPage.css";
import { Helmet } from "react-helmet";

export const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contact: "",
    suggestion: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_yy4iknc", // EmailJS service ID
        "template_pgt14or", // EmailJS template ID
        {
          fullName: formData.fullName,
          email: formData.email,
          contact: formData.contact,
          suggestion: formData.suggestion,
        },
        "dsDIvKufxRyvitjh_" // EmailJS public key
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setMessage("Your message has been sent successfully!");
        },
        (err) => {
          console.error("FAILED...", err);
          setMessage("Failed to send your message. Please try again later.");
        }
      );
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | Lone Wolf Writes</title>
        <meta name="description" content="Contact us Lone Wolf Writes" />
        <link rel="canonical" href="https://lonewolfwrites.com/contact" />
      </Helmet>
      <main>
      <div className="container mt-4">
        <div className="contactForm">
          <div className="card mb-4 contact-card">
            <h1 className="contact-title">Contact Us</h1>
            <p className="contact-description">
              Have questions, suggestions, or just want to say hello? <br />
              We'd love to hear from you!
            </p>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <h4>Full Name</h4>
                <input
                  type="text"
                  name="fullName"
                  className="form-control"
                  placeholder="Enter your name here"
                  required
                  value={formData.fullName}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <h4>Email</h4>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email here"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <h4>Contact</h4>
                <input
                  type="tel"
                  name="contact"
                  className="form-control"
                  placeholder="Enter your contact here"
                  required
                  value={formData.contact}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <h4>Questions or Suggestions</h4>
                <textarea
                  name="suggestion"
                  className="form-control"
                  rows="4" // Adjust number of rows for height
                  placeholder="Enter your questions or suggestions here"
                  required
                  value={formData.suggestion}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <input type="checkbox" required />
                <span> I agree to the <a href="/privacy-policy" target="_blank" style={{ textDecoration: "none", color: "red" }} >Privacy Policy</a></span>
              </div>
              <div className="form-group">
                <button type="submit" className="submit-button">Submit</button>
              </div>
            </form>
            {message && <p className="contact-message">{message}</p>}
            <p className="contact-footer">
              Reach out to our dedicated team at <br />
              <a href="mailto:pranav.gaikwad@lonewolfwrites.com" className="email-link" style={{ textDecoration: "none", color: "red" }}>pranav.gaikwad@lonewolfwrites.com</a>
              <br />
              for prompt and friendly assistance.
            </p>
          </div>
        </div>
      </div>
      </main>
    </>
  );
};
